<template>
  <div class = "pay-page">
    <div class = "logo-img">
      <img src = "https://test.facejournal.cn/tm_0029f00b85ed0183906764cfc316819f_20220126143648.png"/>
    </div>

    <div class = "pay-price">
      <div class = "pay-price-item" v-for = "(item,index) in vipList" :key = "index">
        <p>{{ item.title }}</p>
        <span>{{ parseFloat(item.amount / 100).toFixed(2) }}元</span>
        <van-radio-group v-model = "radio">
          <van-radio :name = "item.id" @click = "radioChange(item.id)" checked-color = "#fdd000"></van-radio>
        </van-radio-group>
      </div>

    </div>

    <div class = "pay-type">
      <h3 class = "title">支付方式</h3>
      <div class = "pay-type-box">
        <div class = "pay-item">
          <van-icon name = "wechat-pay" size = "30" color = "#09bb07"/>
          <span>微信支付</span>
        </div>
        <van-checkbox v-model = "checked" checked-color = "#fdd000"></van-checkbox>
      </div>
    </div>

    <div class="vip-images">
      <img src="https://fenxiao-guogao.wukongkeyan.com/tm_1b464e935016867cedf10e44aad71c8a_20220720180546.jpg"/>
    </div>

    <!-- <div class="pay-agreement">
        <van-checkbox v-model="payChecked" icon-size="18px" checked-color="#fdd000"></van-checkbox>
        <p>已阅读并同意</p>
        <span>《隐私政策》、</span>
        <span>《用户服务协议》</span>
    </div> -->

    <div class = "pay-button">
      <van-button round type = "primary" @click = "joinVip">加入</van-button>
    </div>


  </div>
</template>
<script>
import {getCardList,createOrder} from '../api/index'
import Vue from 'vue';
import {Field, Icon, Checkbox, CheckboxGroup, CountDown, Notify, RadioGroup, Radio} from 'vant';

Vue.use(Icon);
Vue.use(Field);
Vue.use(Checkbox);
Vue.use(CheckboxGroup);
Vue.use(CountDown);
Vue.use(Notify);
Vue.use(Radio);
Vue.use(RadioGroup);

export default {
  data() {
    return {
      telPhone: '',
      telCode: '',
      checkedprice: true,
      checked: true,
      radio: 1,
      sms: '',
      time: 30 * 60 * 60 * 1000,
      vipList: []
    };
  },
  created() {
    this.getCardList();
  },
  methods: {
    //会员列表
    getCardList() {
      getCardList().then(res=>{
        if (res.data.code == 1) {
          this.vipList = res.data.data;
        }
      })
    },
    //选择会员年数
    radioChange(e) {
      this.radio = e;
    },
    // 确定加入会员
    joinVip() {
      createOrder(this.radio).then(res=>{
        let resdata = res.data;
        if (resdata.code == 1) {
          let params = {
            appId: resdata.data.appId,
            nonceStr: resdata.data.nonceStr,
            package: resdata.data.package,
            paySign: resdata.data.paySign,
            signType: resdata.data.signType,
            timeStamp: resdata.data.timeStamp
          };
          let ccidQuery = this.$route.query.ccid  //ccid---客服id
          let ggidQuery = this.$route.query.ggid  //ggid---核销码
          let personQuery = this.$route.query.person  //person---销售
          let webUrl = '?ccid=' + ccidQuery + '&ggid=' + ggidQuery + '&person=' + personQuery
          window.location.href = 'https://pay-v2.keyanhuoye.com/wxMp?data=' + btoa(JSON.stringify(params)) + '&url=' + btoa('https://vip2022.wukongkeyan.com' + '/#/' + webUrl);
        }
      })
    },

  }
};
</script>
<style scoped>
.vip-images{
  padding: 0 0.24rem 1.8rem;
}
.vip-images img{
  width: 100%;
  height: auto;
  border-radius: 0.1rem;
}

.logo-img {
  width: 100%;
  margin-bottom: 0.96rem;
  text-align: center;
}

.logo-img img {
  display: inline-block;
  width: 80%;
}

.pay-page >>> .van-field__label {
  width: 3.2em;
  line-height: 0.72rem;
}

.pay-page >>> .van-field__control {
  height: 0.72rem;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  text-indent: 0.1rem;
}

.pay-page >>> .van-button--primary {
  height: 0.72rem;
  font-size: 0.28rem;
  background: #fdd000;
  border: 0;
}

.pay-page >>> [class*=van-hairline]::after {
  border: 0;
}

.pay-page {
  height: calc(100vh - 0.4rem);
  padding-top: 0.4rem;
  background: #fff;
  box-sizing: border-box
}

.pay-price, .pay-type, .pay-button {
  margin: 0.4rem 0.24rem;
  padding: 0.04rem 0.24rem;
  background: #f5f6f7;
  border-radius: 0.16rem;
  font-size: 0.28rem;
  color: #4c4948;
}

.pay-price .pay-price-item, .pay-type-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.pay-type {
  padding-bottom: 0.4rem;
}

.pay-price-item {
  padding: 0.16rem 0;
}

.pay-price p {
  width: 60%;
  margin: 0.08rem;
  text-align: left;
  font-weight: 600;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.pay-type .title {
  text-align: left;
  font-weight: 400;
  font-size: 0.28rem;
}

.pay-item, .pay-agreement {
  display: flex;
  justify-content: flex-start;
  align-items: center
}

.pay-agreement {
  margin: 0.4rem 0.24rem;
  padding: 0.04rem 0.24rem;
  font-size: 0.24rem;
  color: #4c4948;
}

.pay-agreement p {
  margin-left: 0.16rem;
  color: #b2b2b2;
}

.pay-agreement span {
  color: #4a90e2;
}

.pay-button {
  width: calc(100% - 0.48rem);
  background: transparent;
  margin-left: 0;
  position: fixed;
  bottom: 0.24rem;
}

.pay-button .van-button {
  width: 100%;
  background: #fdd000;
  color: #fff;
  border: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/pay.vue